export class TicketStatus {
  public ticketStatusId: number = 0;
  public servicentreTextualCode: string = '';
  public nameFr: string = '';
  constructor() {}
}
